// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 100vw;
  margin: 0 auto;
  overflow-x: hidden;
}

.chatbox-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.patient-information {
  position: absolute;
  top: 50px;
  right: 50px; /* Change left to right */
  margin: 0;
  text-align: left;
  color: rgba(211, 203, 203, 0.736);
  background-color: rgb(30 28 36 / 66%);
  padding: 10px;
  border-radius: 8px;
}

.cs-typing-indicator {
  background-color: #fff0;
}
.cs-message-list {
  background-color: #fff0;
}
#dark .app-container {
  background-color: #242530;
  /* background-color: red; For browsers that do not support gradients */
  background-image: linear-gradient(#141f31, rgba(23, 10, 40, 0.412));
}

#light .app-container {
  background-color: rgb(255, 255, 255);
}
h2 {
  margin: 0;
  text-align: left;
  color: rgb(29, 24, 24);
  text-align: center;
  position: relative;
}

.switch {
  display: flex;
  gap: 5px;
  width: 150px;
  height: 100px;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

#light .switch label {
  color: black;
}

#dark .switch label {
  color: white;
}

.responseTime {
  display: flex;
  justify-content: center;
  align-items: self-start;
  border-radius: 10px;
  padding-left: 20px;
  padding-right: 20px;
  margin-left: 20px;
}

#dark .responseTime {
  background-color: #1b202d;
  color: white;
}

#light .responseTime {
  background-color: #dad8d8;
  color: black;
}

textarea {
  width: 100%;
  min-height: 150px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  background-color: #ffffff;
  font-size: 16px;
  resize: none;
}

.bot-version {
  border: none;
}

@media screen and (max-width: 880px) {
  h2 {
    left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW,EAAE,yBAAyB;EACtC,SAAS;EACT,gBAAgB;EAChB,iCAAiC;EACjC,qCAAqC;EACrC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,sEAAsE;EACtE,mEAAmE;AACrE;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,OAAO;EACT;AACF","sourcesContent":[".app-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  max-width: 100vw;\n  margin: 0 auto;\n  overflow-x: hidden;\n}\n\n.chatbox-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.patient-information {\n  position: absolute;\n  top: 50px;\n  right: 50px; /* Change left to right */\n  margin: 0;\n  text-align: left;\n  color: rgba(211, 203, 203, 0.736);\n  background-color: rgb(30 28 36 / 66%);\n  padding: 10px;\n  border-radius: 8px;\n}\n\n.cs-typing-indicator {\n  background-color: #fff0;\n}\n.cs-message-list {\n  background-color: #fff0;\n}\n#dark .app-container {\n  background-color: #242530;\n  /* background-color: red; For browsers that do not support gradients */\n  background-image: linear-gradient(#141f31, rgba(23, 10, 40, 0.412));\n}\n\n#light .app-container {\n  background-color: rgb(255, 255, 255);\n}\nh2 {\n  margin: 0;\n  text-align: left;\n  color: rgb(29, 24, 24);\n  text-align: center;\n  position: relative;\n}\n\n.switch {\n  display: flex;\n  gap: 5px;\n  width: 150px;\n  height: 100px;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n}\n\n#light .switch label {\n  color: black;\n}\n\n#dark .switch label {\n  color: white;\n}\n\n.responseTime {\n  display: flex;\n  justify-content: center;\n  align-items: self-start;\n  border-radius: 10px;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-left: 20px;\n}\n\n#dark .responseTime {\n  background-color: #1b202d;\n  color: white;\n}\n\n#light .responseTime {\n  background-color: #dad8d8;\n  color: black;\n}\n\ntextarea {\n  width: 100%;\n  min-height: 150px;\n  padding: 12px 20px;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  background-color: #ffffff;\n  font-size: 16px;\n  resize: none;\n}\n\n.bot-version {\n  border: none;\n}\n\n@media screen and (max-width: 880px) {\n  h2 {\n    left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
